import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';

import * as fromJobStatus from './job-status.reducer';

export interface Job {
  jobStatus: fromJobStatus.JobState;
}

export const reducers: ActionReducerMap<Job> = {
  jobStatus: fromJobStatus.reducer
};

export const getJobState = createFeatureSelector<Job>('jobStatus');

export * from './job-status.reducer';
